
import {INotificationFilterTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationFilterTypeStrategy'
import {INotificationResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'

export class AllNotificationFilterTypeStrategy implements INotificationFilterTypeStrategy {
  updateNotificationsByNotificationFilterTypeMap(notificationsByNotificationFilterTypeMap: Map<NotificationFilterType, INotificationResponseInstance<NotificationType>[]>): Map<NotificationFilterType, INotificationResponseInstance<NotificationType>[]> {
    const newMap = new Map(notificationsByNotificationFilterTypeMap)
    const mentionedInMessageNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.Mentions) || []
    const assignedToMeNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.AssignedToMe) || []
    const allNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.All) || []
    const updatedMentionedInMessageNotifications = mentionedInMessageNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
      }
      return notification
    })
    const updatedAssignedToMeNotifications = assignedToMeNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
      }
      return notification
    })
    const updatedAllNotifications = allNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
      }
      return notification
    })

    newMap.set(NotificationFilterType.Unread, [])
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.Mentions)) {
      newMap.set(NotificationFilterType.Mentions, updatedMentionedInMessageNotifications)
    }
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.AssignedToMe)) {
      newMap.set(NotificationFilterType.AssignedToMe, updatedAssignedToMeNotifications)
    }
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.All)) {
      newMap.set(NotificationFilterType.All, updatedAllNotifications)
    }
    return newMap
  }
  isNotificationMatchingFilterType(notification: INotificationResponseInstance<NotificationType>): boolean {
    return true
  }
}

